import {
  Table,
  Select,
  Modal,
  Checkbox,
  Drawer,
  Popover,
  Typography,
  Dropdown,
  Button,
  Space,
  MenuProps,
  Segmented,
} from "antd";
import React, { Suspense, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./platformTableComponent.scss";
import ViewRecord from "../viewRecord/viewRecord";
import {
  deleteRecordRequest,
  downloadUserReportRequest,
} from "../../screens/users/states/action";
import ColumnsBuilder from "../../utils/columnBuilder";
import { TableRowSelection, SelectionSelectFn } from "antd/lib/table/interface";

import { Notification } from "../notification/notification";
import { useLocation, useSearchParams } from "react-router-dom";
import {
  AppstoreOutlined,
  BarsOutlined,
  DownOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";

import { BulkUploadAction, IColumn } from "../../types/field";
import { AccessLevel, RowLevelAction, section, StepDetailProps } from "../../types/types";
import {
  getLoggedInUserModuleAccess,
  isActionAllowedToUser,
} from "../../utils/utils";

import moment from "moment";
import { DateFormat, DateWithTimeFormate } from "./dateFormat";
import BulkUpload from "../../components/bulkUpload";
import {
  javascriptActionFns,
  javascriptRecordActionFns,
} from "./platformTableActionUtils";

import HighlightsComponent from "../../components/highlightsComponent/highlightsComponent";
import { GetRequest, replaceWithCurrentApiVersion } from "../../utils/api";
import { useTranslation } from "react-i18next";
import store from "../../store";
import { Props, SearchFormType, TableParams } from "./types";
import { reloadDetailsPage } from "../../states/actions";
import { customEmptyMessage } from "./GenericTableUtils";
import CustomIcon from "../icons/CustomIcon";
import CustomLoader from "../loader";
import CardList from "./cardList";
import CardGrid from "./cardGrid";
import { isMobile } from "react-device-detect";
import DataTableFilter from "../dataTableFilter/dataTableFilter";


const SearchFilterModule = React.lazy(() => import("../searchModule/searchFilterModule"));
const AutoAllocation = React.lazy(() => import("../recordDetails/autoAllocation"));
const ViewProfile = React.lazy(() => import("../../screens/profiles/viewProfile"));

const { Text } = Typography;
const CheckboxGroup = Checkbox.Group;
const { confirm } = Modal;


const PlatformTableComponent: React.FC<Props> = ({
  title = "",
  bluePrintApi,
  searchApi = "",
  moduleCode,
  moduleAccessLevel,
  renderCustomDetailPage,
  handleRowSelectionCallback,
  onLoadingResponse,
  autoReconRowSelectionEnabled = false,
  handleRowLevelActionCallback,
  handleTopLevelActionCallback,
  captureRowOnActionClickCallback,
  allowedActionsForRenderingCustomDetailPage,
  extraActionsOnRecordCallback,
  openInFieldSearchModal = false,
  searchFieldKey
}) => {

  const { t } = useTranslation();

  const dispatch = useDispatch();
  const rootState = useSelector((state: any) => state?.userReducer);

  const [openAction, setOpenAction] = useState(false);
  const [uniqueIds, setuniqueIds] = useState<any[]>([]);
  const [uniqueLoanNos, setuniqueLoanNos] = useState<any[]>([]);
  const [uniqueCustomerNames, setuniqueCustomerNames] = useState<any[]>([]);

  //----------_TOM_FIXING_DATA_GETTING_OVERRIDDEN_BEGIN---------------
  const [columnData, setColumnData] = useState<any>();

  const [searchData, setSearchData] = useState<any>();
  const [data, setData] = useState<{ records: [] }>({ records: [] });
  const [tableLoading, setTableLoading] = useState<boolean>(true);

  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [rowItemData, setRowItemData] = useState<any>();

  const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);

  const searchString = useRef<string>("");
  const searchFilterRef = useRef<any[]>();

  const [actionUrl, setActionUrl] = useState("");
  const [recordHeaderDetails, setRecordHeaderDetails] = useState<section>();
  const [stepDetailsOfRecord, setStepDetailsOfRecord] = useState<StepDetailProps>({ screens: [] });
  const [isEditAllowed, setIsEditAllowed] = useState<boolean>(true);
  const [bulkUploadAction, setBulkUploadAction] = useState<BulkUploadAction>();
  const [renderCustomViewPage, setRenderCustomViewPage] = useState<boolean>(false);
  const [isCreateFlow, setIsCreateFlow] = useState<boolean>(false);
  const [recordDetailsDataApi, setRecordDetailsDataApi] = useState<string>();
  const [platformAction, setPlatformAction] = useState<RowLevelAction>("VIEW" as RowLevelAction);
  const [isRelatedInfo, setIsRelatedInfo] = useState<boolean>(false);
  const [isNewRelatedInfo, setIsNewRelatedInfo] = useState<boolean>(false);

  let [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      current: 1,
      pageSize: 10,
      total: 10,
    }
  });

  const [SelectedTotal, SetSelectedTotal] = useState(0);

  const [openBulkUpload, setBulkUpload] = useState(false);
  const [disableNextButton, setDisableNextButton] = useState(false);

  let loggedInUserAccess: AccessLevel = getLoggedInUserModuleAccess(moduleCode ?? "", moduleAccessLevel);
  let totalField: any;

  let {
    deleteRecordData: { data: deleteRecordData },
    userDataSave: { data: userDataSave },
    createNewRecord: { data: createNewRecord },
  } = rootState || {};

  let { searchForm }: SearchFormType = searchData || {};

  const [records, setRecords] = useState<any>([]);
  const [sortInfo, setSortInfo] = useState({
    columnKey: '',
    order: ''
  });

  const location = useLocation();
  let newsinglecolumn: string = "";
  //----------_TOM_FIXING_DATA_GETTING_OVERRIDDEN_BEGIN---------------

  // Loading Table Headers and Table Search Filters based on[blueprintApi, SearchApi]

  //This boolean is used to load recordDetails page when reloading details page manually 
  //Reloading details page is restricted to recordDetails page or same details page from which reload was triggered 
  //In case the relading needs to happen in same details page do to change this to true in below method.
  const isReloadDetailsPage = useRef(false);
  const callbackRef: any = useRef(null);
  const sideDrawerTitle = useRef<string>(title);
  const [searchParams] = useSearchParams();

  if (searchParams.get('search')) {
    searchString.current = "&search=" + window.atob(searchParams.get('search') as string);
  }

  useEffect(() => {
    // Define the callback function
    callbackRef.current = () => {
      // Your callback logic here
      let iniState: any = store.getState().initialReducer;
      if (iniState.reloadDetailsPage && iniState.reloadDetailsPage.data.recordId) {
        handleReloadingDetailsPage(iniState.reloadDetailsPage.data);
      }
    };

    // Subscribe to the store
    const unsubscribe = store.subscribe(() => {
      if (callbackRef.current) {
        callbackRef.current();
      }
    });

    // Cleanup subscription on unmount
    return () => {
      unsubscribe();
    };
  }, []);

  //This method is used to reload the deatils page ie., side-drawer
  async function handleReloadingDetailsPage(dataForNewDetailsPage: any) {

    let action = dataForNewDetailsPage.action;

    //Fetch record data with filters API 
    const res = await GetRequest(dataForNewDetailsPage.dataApi + "?size=1&page=0&search=" + dataForNewDetailsPage.recordId + ":eq" + dataForNewDetailsPage[dataForNewDetailsPage.recordId]);

    isReloadDetailsPage.current = true;
    if (res.records.length > 0) {
      handleRowLevelAction(action, res.records[0]);
    } else {
      Notification("info", "No Record Found for Given ID");
    }
  }

  useEffect(() => {
    if (bluePrintApi && bluePrintApi.length > 0) {
      fetchDataTable();
    }

  }, [bluePrintApi]);

  useEffect(() => {
    if (onLoadingResponse) {
      onLoadingResponse(data, searchFilterRef.current, searchString.current);
    }
  }, [data]);

  const columnList = useRef<any>([]); //This is used for hide columns feature

  const [displayMode, setDisplayMode] = useState<string>(isMobile ? "cards" : "table");

  const emptyMessageString = useRef<string>("No Records Found");

  const fetchDataTable = async () => {

    try {
      let blueprintApiResponse = await GetRequest(bluePrintApi);

      let searchApiResponse;

      if (searchApi) {
        searchApiResponse = await GetRequest(searchApi);
        setSearchData(searchApiResponse);
        await fetchDataTableRecords(blueprintApiResponse.dataApi, 10, 0, searchApiResponse.searchForm);
      } else {
        await fetchDataTableRecords(blueprintApiResponse.dataApi, 10, 0, []);
      }

      setColumnData(blueprintApiResponse);

      if (isMobile && blueprintApiResponse.hasOwnProperty("enableMultipleDisplayModes") && blueprintApiResponse.enableMultipleDisplayModes) {

        if (moduleCode === "users") {
          setDisplayMode("list");
        } else {
          setDisplayMode("cards");
        }

      } else {
        setDisplayMode(blueprintApiResponse.defaultDisplayMode ?? "table");
      }


      if (blueprintApiResponse.hasOwnProperty("dataByDefault") && blueprintApiResponse.dataByDefault === false) {

        let mandatorySearchFields = searchApiResponse.searchForm.map((item: any) => {
          if (item.hasOwnProperty("mandatory") && item.mandatory) {
            return item.displayName;
          }
        });

        emptyMessageString.current = "Please select " + mandatorySearchFields.toString() + " to get records";
      }

      let temp: any[] = [];
      blueprintApiResponse.dataGrid.forEach((col: any) => {
        if (col.hasOwnProperty("display") && !col.display) {
          return;
        }
        temp.push({
          label: col.displayName,
          value: col.field
        });
      });
      columnList.current = temp;

    } catch (error) {

      if(error !== "Unauthorized") {
        Notification("error", "Failed to load Table");
      }
      
    };

  };


  const handleData = (data: any) => {

    let record = data?.records?.map((item: any, index: number) => {
      let tempItem = { ...item };
      columnData?.dataGrid?.forEach((field: any) => {
        let criteria = field.visibilityCriteria ?? "true";

        if (criteria !== "true") {
          columnData?.dataGrid.forEach((field1: any) => {
            criteria = criteria.replaceAll("field." + field1.field + " ", "'" + item[field1.field] + "'");
          });
        }

        if (!eval(criteria)) {
          tempItem[field.field] = undefined;
        } else {
          if (field.type === 'file-download-link') {
            let url = field.url ?? "";
            columnData?.dataGrid.forEach((field1: any) => {
              url = url.replaceAll("{" + field1.field + "}", item[field1.field] ?? "");
            });
            let recordId = item[mappings.recordId];
            tempItem[field.field] = (<a href="#" onClick={() => {
              if (field.onClick === 'javascript') {
                let methodName: string = field?.method!;
                let fn = javascriptRecordActionFns.get(methodName);
                if (fn) {
                  dispatch(downloadUserReportRequest(fn(item, recordId, field?.args)));
                }
              } else {
                dispatch(downloadUserReportRequest(url));
              }
            }}> {item[field.field]}</a>)
          }
        }

      });

      return (item = {
        ...tempItem,
        srno:
          index +
          1 +
          ((tableParams?.pagination?.current || 1) *
            (tableParams?.pagination?.pageSize || 1) -
            (tableParams?.pagination?.pageSize || 1)),
      });
    });
    setRecords(record)
  };

  //----------_TOM_FIXING_DATA_GETTING_OVERRIDDEN_END---------------
  useEffect(() => {
    const fetchData = async () => {
      if (columnData?.dataApi) {
        await fetchDataTableRecords(columnData?.dataApi, 10, 0, searchForm);
      }
    }
    fetchData()
  }, [deleteRecordData, userDataSave, createNewRecord]);

  useEffect(() => {
    reloadDataTableRecords(tableParams?.pagination);
  }, [tableParams]);

  const reloadDataTableRecords = (config: any) => {

    if (columnData?.dataApi) {
      fetchDataTableRecords(
        columnData?.dataApi,
        Number(config?.pageSize),
        Number(config?.current) - 1,
        searchForm
      );
    }
  };

  const doesAllMandatorySearchFiltersSelected = (searchFormFields: any) => {

    let searchUrl = JSON.stringify(searchString.current);
    let mandatorySearchFields: [] = searchFormFields?.filter((search: any) => search?.mandatory === true) ?? [];

    return mandatorySearchFields.every((field: any) => searchUrl.includes(field.field ?? "" + ":"));

  }

  const fetchDataTableRecords = async (api: string, size: number, page: number, searchFormFields: any) => {

    let searchUrl = searchString.current ?? ""; //search string will contain the query params for search

    let charToAppendParams = api.includes("?") ? "&" : "?";
    const url = `${api}${charToAppendParams}size=${size}&page=${page}${searchUrl}`;
    setTableLoading(true);

    let response = doesAllMandatorySearchFiltersSelected(searchFormFields) ? await GetRequest(url) : { records: [] };

    // if records are less than expected, disable next button. 
    if (response.records.length < size) {
      setDisableNextButton(true);
    } else {
      setDisableNextButton(false);
    }

    setData(response);
    setTableLoading(false);

    return response;
  };


  useEffect(() => {
    handleData(data);
  }, [data]);

  let { mappings } = columnData || {};

  const handleTableRowSelection: SelectionSelectFn<any> = (record) => {
    handleRowSelectionCallback?.(record, mappings);
  };

  const AutoReconRowSelectionConfig: TableRowSelection<any> = {
    // type: 'radio'
    onSelect: handleTableRowSelection,
  };

  const commonRowSelectionConfig: TableRowSelection<any> = {

    onSelect: (record, checked) => {

      handleCheckBoxAction(checked, record);

      handleSelectRow(record, checked);

      if (checked) {
        SetSelectedTotal(SelectedTotal + record?.[totalField]);
      } else {
        SetSelectedTotal(SelectedTotal - record?.[totalField]);
      }
    },

    onSelectAll: (selected) => {

      handleSelectAll(selected);
    },
    defaultSelectedRowKeys: selectedRows.map((item) => item[mappings["recordId"]]),
    preserveSelectedRowKeys: true

  };

  const platformTableCheckboxEnabled = useRef<boolean>(false);

  const getRowSelectionConfig = () => {

    if (autoReconRowSelectionEnabled) {
      return AutoReconRowSelectionConfig
    }

    if (platformTableCheckboxEnabled.current) {
      return commonRowSelectionConfig;
    }

    return undefined;
  }

  const handleSelectRow = (record: any, selected: any) => {


    if (selected) {
      setSelectedRows([...selectedRows, record]);
    } else {
      setSelectedRows(
        selectedRows.filter((key: any) => {
          return (
            key[columnData.mappings.recordId] !==
            record[columnData.mappings.recordId]
          );
        })
      );
    }
  };

  const handleSelectAll = (selected: any) => {
    let newtotal = 0;
    let property = mappings["recordId"] ?? 'srno';
    const ids: any[] = [];


    if (selected) {

      data.records.map((record: any) => {
        newtotal += record?.[totalField];
        handleCheckBoxAction(true, record);
        ids.push(record[property]);
      });

      setSelectedRows([...data.records]);
      SetSelectedTotal(newtotal);

    } else {
      setSelectedRows([]);
      handleResetSelection();
    }
    setuniqueIds(ids);
  };

  const handleResetSelection = () => {

    setSelectedRows([]);
    setuniqueIds([]);
    SetSelectedTotal(0);
  };

  const getRowClassName = (record: any) => {
    // Access the 'color' property from your data and use it to set the background color
    return record.newInfoUpdated === true ? 'highlighted-table-row' : ''; // You can also set a default color if 'color' is not present
  };

  const createTableHeaders = () => {

    const columns = [
      {
        title: "SNo",
        dataIndex: "srno",
        key: "srno-key",
        sorter: false,
        render: (records: any) => {
          return <div className="px-2" style={{ minWidth: "40px" }}>
            {records}
          </div>
        }
      }
    ] as any;

    columnData && columnData?.dataGrid && columnData?.dataGrid?.filter((f: IColumn) => {
      return !(Object.keys(f).includes("display") && !f.display);
    }).forEach((col: IColumn) => {

      let singleColumn: any = {
        title: t(`${col?.displayName}`),
        dataIndex: `${col?.field}`,
        key: `${col.field || col.displayName}`,

        onCell: (record: any) => {
          return openInFieldSearchModal && searchFieldKey === col?.field ? ({
            style: {
              cursor: 'pointer',
              textDecoration: 'underline',
            },

            onClick: () => {
              // Dispatch your custom event here
              const customEvent: any = new Event('onSearchFieldSelect');
              const detail = { field: col.field, value: record[col.field] };

              customEvent.detail = detail;
              document.dispatchEvent(customEvent);
            },
          }) : ({});
        },
        sortOrder: sortInfo?.columnKey === col?.field && sortInfo?.order,
        sorter: (a: any, b: any) => {
          const aValue = a[col?.field] == undefined || null ? '' : a[col?.field];
          const bValue = b[col?.field] == undefined || null ? '' : b[col?.field];
          if (col?.field === "srno") {
            return 0;
          }

          if (typeof aValue === "string" && typeof bValue === "string") {
            return aValue.localeCompare(bValue);
          }

          return aValue - bValue;
        },
        sorterIcon: (sortOrder: any) => (
          <span
            className={`custom-sort-icon ant-table-sorter-icon-${sortOrder}`}
          />
        ),
        defaultSortOrder: 'ascend',
        sortDirections: ['ascend', 'descend', 'ascend'],
        showSorterTooltip: false,
        checkBox: `${col?.checkBox}`,
        render: (recordVal: any) => {

          return (
            <div className={'table-cell-width pr-2 ' + 'text-' + col?.align}>
              {recordVal}
            </div>
          )

        },
      };

      if (col?.type === "date") {
        singleColumn = {
          ...singleColumn,
          render: (records: any) => {
            return (
              <div>
                {moment(records || null).format(DateFormat) ===
                  "Invalid date" ? (
                  records === null ? (
                    <div className="table-cell-width"></div>
                  ) : (
                    <div className="table-cell-width">
                      {records}{" "}
                    </div>
                  )
                ) : (
                  <div className="table-cell-width">
                    {moment(records).format(DateFormat)}
                  </div>
                )}
              </div>
            );
          },
        };
      }

      if (col?.type === "time") {
        singleColumn = {
          ...singleColumn,
          render: (records: any) => {
            return (
              <div className="table-cell-width">
                {moment(records || null).format(DateWithTimeFormate) ===
                  "Invalid date"
                  ? records
                  : moment(records).format(DateWithTimeFormate)}
              </div>
            );
          },
        };
      }

      if (col?.checkBox) {

        totalField = columnData.totalField;
        platformTableCheckboxEnabled.current = true;

      }

      if (!col?.checkBox) {
        columns.push(singleColumn);
      }



    });


    columns.map((singlecolumn: any) => {
      if (singlecolumn.checkBox === "true") {
        newsinglecolumn = singlecolumn.title;
      }
    });

    if (
      columnData &&
      !openInFieldSearchModal &&
      ((columnData?.rowLevelactions &&
        columnData?.rowLevelactions.length > 0) ||
        columnData?.enableMultiSelect)
    ) {
      columns?.push({
        title: "Action",
        key: "action",
        fixed: "right",
        width: 100,
      });
    }

    return columns;
  };


  const showRowLevelAction = (item: any, record: any) => {

    let visibilityCriteria = item?.visibilityCriteria;

    if (visibilityCriteria) {
      Object.keys(record).forEach((key: string) => {
        visibilityCriteria = visibilityCriteria.replaceAll("field." + key + " ", "'" + record[key] + "'");
      });


      try {
        return eval(visibilityCriteria);
      } catch (err) {
        console.error(err);
        return false;
      }
    }
    return true;
  };

  const showDeleteConfirmationDialog = (item: any, record: any) => {
    confirm({
      title: "Do you Want to delete this item?",
      okText: "Yes",
      okButtonProps: {
        className: "bg-primary"
      },
      cancelButtonProps: {
        className: "border-primary text-primary"
      },
      cancelText: "No",
      onOk() {
        dispatch(
          deleteRecordRequest({
            api: item?.dataApi,
            recordId: record && record[mappings["recordId"]],
          })
        );
      },
      onCancel() { },
    });
  };

  //Handles actions in table action column
  const handleRowLevelAction = (action: any, record: any) => {

    sideDrawerTitle.current = title;

    action.action = getRowActionForItem(record, action);

    if (action?.type === 'file-download-link') {
      let url = action.url ?? "";
      columnData?.dataGrid.forEach((field1: any) => {
        url = url.replaceAll("{" + field1.field + "}", record[field1.field] ?? "");
      });

      if (action.onClick === 'javascript') {
        let methodName: string = action?.method!;
        let fn = javascriptRecordActionFns.get(methodName);
        if (fn) {
          let recordId = record[mappings.recordId];
          dispatch(downloadUserReportRequest(fn(record, recordId, action?.args)));
        }
      } else {
        dispatch(downloadUserReportRequest(url));
      }
      return;
    }

    if (captureRowOnActionClickCallback) {
      captureRowOnActionClickCallback(record);
    }

    if (handleRowLevelActionCallback !== undefined) {
      handleRowLevelActionCallback(action, record);
      return;
    }

    setRowItemData(record);
    setOpenAction(true);
    setIsCreateFlow(false);
    setIsRelatedInfo(true);
    setIsNewRelatedInfo(true);
    setRecordDetailsDataApi(action.dataApi);

    if (action.action === "Create") {
      setIsCreateFlow(true);
    }

    setRenderCustomViewPage(action?.renderCustomComponent ?? false);
    setActionUrl(action?.blueprintApi);
    setRecordHeaderDetails(action?.header);

    if (action?.blueprintOnRecordType) {

      let fieldValue = record[action?.blueprintOnRecordType.fieldName];
      let defaultApi = action?.blueprintOnRecordType.recordTypeConditions.find(
        (condition: { value: any }) => condition?.value === fieldValue
      );

      if (defaultApi) {
        setActionUrl(defaultApi?.api);
      }

    }

    setIsEditAllowed(action?.allowEdits);

    setPlatformAction(action.action.toUpperCase() as RowLevelAction);
    setStepDetailsOfRecord(action?.stepDetails ?? { screens: [] });

  };

  const handleTopLevelAction = (action: any) => {


    if (handleTopLevelActionCallback !== undefined) {
      handleTopLevelActionCallback(action, selectedRows);
      return;
    }

    if (action.actionType === "javascript") {
      let methodName: string = action?.method!;
      let fn = javascriptActionFns.get(methodName);

      if (fn) {
        fn(selectedRows, action?.args, reloadData, action);
        return;
      }
    }

    if ((action.displayName === "Generate Bank PIS" ||
      action.displayName === "Generate System PIS") &&
      SelectedTotal === 0
    ) {
      Notification("error", "Select a record");
      return;
    }

    if (
      action.displayName === "Generate System PIS" &&
      selectedRows[0].paymentMode !== "C" &&
      selectedRows.filter((record: any) =>
        ["Q", "P", "D"].includes(record.paymentMode)
      ).length !== selectedRows.length
    ) {
      Notification("error", "Please select the receipts of same the payment mode");
      return;
    }

    if (
      action.displayName === "Generate System PIS" &&
      selectedRows[0].paymentMode === "C" &&
      selectedRows.filter((record: any) => ["C"].includes(record.paymentMode))
        .length !== selectedRows.length
    ) {
      Notification("error", "Please select the receipts of the same payment mode");
      return;
    }

    if (
      action.displayName === "Generate Bank PIS" &&
      selectedRows[0].paymentMode !== "C" &&
      selectedRows.filter((record: any) => ["B"].includes(record.paymentMode))
        .length !== selectedRows.length
    ) {
      Notification("error", "Please select the SPIS of the same payment mode");
      return;
    }

    if (
      action.displayName === "Generate Bank PIS" &&
      selectedRows[0].paymentMode === "C" &&
      selectedRows.filter((record: any) => ["C"].includes(record.paymentMode))
        .length !== selectedRows.length
    ) {
      Notification("error", "Please select the SPIS of the same payment mode");
      return;
    }

    // check for bulk assign - if Row is selected or not
    if (selectedRows.length === 0 && (action.displayName === 'Bulk Assign' || action.displayName === 'Approve' || action.displayName === 'Reject')) {
      Notification("error", "Please select atleast one row");
      return;
    }

    switch (action.action) {
      case "Create":
        setOpenAction(true);
        setIsCreateFlow(true);
        setIsRelatedInfo(false);
        setIsNewRelatedInfo(false);
        setRenderCustomViewPage(action?.renderCustomComponent ?? false);
        setActionUrl(action.blueprintApi ?? "");
        setPlatformAction("CREATE" as RowLevelAction);
        break;

      case "CreateWithContext":
        setIsCreateFlow(true);
        setIsRelatedInfo(false);
        setRenderCustomViewPage(action?.renderCustomComponent ?? false);
        setActionUrl(action.blueprintApi ?? "");
        setOpenAction(true);
        setPlatformAction("CREATEWITHCONTEXT" as RowLevelAction);
        break;

      case "BulkUpload":
        setBulkUploadAction(action as BulkUploadAction);
        showBulkUpload();
        break;

      default:
        // Handle any other cases if necessary
        break;
    }

  };

  const handleCheckBoxAction = (checked: boolean, record: any) => {
    let ids = [...uniqueIds];
    let loanNos = [...uniqueLoanNos];
    let customerNames = [...uniqueCustomerNames];
    let rows = [...selectedRows];
    // as agreed we only check for recordId
    let property = mappings["recordId"];
    let id = record[property];
    let property1 = mappings["loanNo"];
    let loanNo = record[property1];
    let property2 = mappings["customerName"];
    let customerName = record[property2];

    if (checked) {
      ids.push(id);
      loanNos.push(loanNo);
      customerNames.push(customerName);
      rows.push(record);
    } else {
      ids = ids.filter((x) => x !== id);
      rows = rows.filter((row) => row["srno"] !== record["srno"]);
    }
    setuniqueIds(ids);
    setuniqueLoanNos(loanNos);
    setuniqueCustomerNames(customerNames);
    setSelectedRows(rows);
  };

  const getRowActionForItem = (record: any, item: any) => {
    if (item.actionType === 'derived' && item.actions !== undefined) {
      let actionVal = item.actions.find((act: any) => {

        let criteria = act.criteria;

        Object.keys(record).forEach((key: string) => {
          if (key && key.length > 0) {
            criteria = criteria.replaceAll("field." + key + " ", (record[key] ? ("'" + record[key] + "'") : "''"));
          }
        });

        try {
          return eval(criteria);
        } catch (err) {
          console.error(err);
          return false;
        }
      });

      if (actionVal) {
        item.action = actionVal.actionName;
      }
    }

    return item.action;
  }


  const handleActionsButton = (record: any) => {

    if (columnData && columnData?.rowLevelactions) {
      return (
        <div className="table-actions-cell-width">
          {columnData?.rowLevelactions
            .filter((item: any) =>
              isActionAllowedToUser(loggedInUserAccess, getRowActionForItem(record, item))
            )
            .filter((item: any) => showRowLevelAction(item, record))
            .map((item: any, index: number) => {
              if (item?.action === "delete") {
                return (
                  <span key={index} className="text-primary">

                    <CustomIcon onClick={() => {
                      showDeleteConfirmationDialog(item, record);
                    }} height="18px" width="18px" title={item?.iconToolTip} name={item?.displayName || 'faEdit'}></CustomIcon>
                  </span>
                );
              } else {
                return (
                  <>
                    <span key={index} className="text-primary">
                      <CustomIcon height="18px" width="18px" title={item?.iconToolTip} onClick={() => handleRowLevelAction(item, record)} className="d-inline-block pointer mr-2" name={item?.displayName || 'fa-edit'}></CustomIcon>
                    </span>
                  </>
                );
              }
            })}
          {columnData?.enableMultiSelect ? (
            <>
              <Checkbox
                onChange={(e: any) => {
                  handleCheckBoxAction(e.target?.checked, record);
                  handleSelectRow(record, e.target.checked);
                }}
                checked={
                  selectedRows.filter((key: any) => {
                    return (
                      key[columnData.mappings.recordId] ===
                      record[columnData.mappings.recordId]
                    );
                  }).length > 0
                    ? true
                    : false
                }
              ></Checkbox>
            </>
          ) : (<></>)}

          {columnData.moreActions && handleMoreActions(record)}

        </div>
      );
    }
  };




  const handleMoreActions = (record: any, mode: 'Button' | 'Icon' = 'Icon') => {


    const demoObj = columnData.moreActions;
    const items: MenuProps['items'] = demoObj.map((item: any, index: number) => {


      let menuItem = {
        key: index,
        label: (
          <span className="text-base px-2 py-2">
            {item.action.displayName}
          </span>
        ),
        onClick: () => {
          item[item.recordId] = record[item.recordId];
          dispatch(reloadDetailsPage(item));
          sideDrawerTitle.current = item.action.displayName;
        }
      };
      return menuItem;

    });


    return (
      <Dropdown menu={{ items }} trigger={['click']}>

        {mode === 'Icon' ? <CustomIcon name="moreVertical" className="text-primary font-bold text-xs" style={{ verticalAlign: "middle" }}></CustomIcon> : <Button className="ml-2" >More</Button>}

      </Dropdown>
    )
  }

  function disableTopActionButton(action: any): boolean {
    if (
      (action.displayName === "Generate Bank PIS" ||
        action.displayName === "Generate System PIS") &&
      SelectedTotal === 0
    ) {
      return true
    }
    if (selectedRows.length === 0 && (action.displayName === 'Bulk Assign' || action.displayName === 'Approve' || action.displayName === 'Reject')) {
      return true
    }
    if (action?.disable) {
      return eval(action?.disable);
    }

    return false
  }


  const reloadData = () => {
    setSortInfo({ columnKey: '', order: '' });
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
    });
    SetSelectedTotal(0);
    setSelectedRows([]);
  };

  const [topLevelActionGroups, setTopLevelActionGroups] = useState<Map<string, MenuProps>>(new Map());

  const addValueToMap = (key: string, value: MenuProps) => {
    // Create a new Map instance with the updated values
    const newMap = new Map(topLevelActionGroups);
    newMap.set(key, value);
    setTopLevelActionGroups(newMap); // Set the new Map as the state
  };

  useEffect(() => {
    if (columnData && columnData.actions) {
      columnData.actions
        ?.filter((item: any) => isActionAllowedToUser(loggedInUserAccess, item.action) && item.actionType === 'GroupOfActions')
        .map((action: any, index: number) => {
          getActionsOfGroup(action);
        });
    }

  }, [columnData]);

  const getActionsOfGroup = async (action: any) => {
    let actions: any = [];
    if (action.loadActionsApi && action.action === 'BulkUpload') {
      actions = await fetchActionsDropDownValues(action.loadActionsApi);
    } else {
      actions = action.actions ?? [];
    }
    const items = actions.map((a: any, index: number) => {
      return { label: a.displayName, key: index }
    });

    addValueToMap(action.displayName, {
      items,
      onClick: (e: any) => {
        handleTopLevelAction(actions[e.key]);
      }
    });
  }

  const fetchActionsDropDownValues = async (api: string) => {

    return GetRequest(replaceWithCurrentApiVersion(api)).then((res: any) => {
      return res?.records.map((r: any) => {
        return {
          action: "BulkUpload",
          displayName: r.displayName,
          iconName: "fa-upload",
          templateDownloadUrl: r.templateDownloadUrl,
          uploadUrl: r.uploadUrl,
          fileUploadFieldLabel: r.fileUploadFieldLabel,
          templateFileNamePrefix: r.templateFileNamePrefix

        };
      });
    }).catch((error: any) => {
      return Promise.reject([]);
    });
  }

  const renderTopLevelActions = () => {

    if (columnData && openInFieldSearchModal === true) {
      return <></>
    }

    if (columnData) {
      //Top level button 

      return (
        <div className="d-flex">
          <div className="flex justify-content-between my-2">

            {columnData.actions
              ?.filter((item: any) =>
                isActionAllowedToUser(loggedInUserAccess, item.action)
              ).map((action: any, index: number) => {

                if(action.action === "DataTableFilter") {
                  return <DataTableFilter bluprintApi={action.blueprintApi} dropDownCode={action.dropDownCode} dorpDownLabel={action.dropDownLabel} onChange={(res: string) =>{
                    
                    if(res === "") {
                      fetchDataTable();
                      return;
                    }

                    const temp = columnData;
                    temp.dataApi = res;
                    setColumnData(temp);
                    fetchDataTableRecords(res, 10, 0, null);
                  } } dataApiMap={action.dataApiMap}></DataTableFilter>
                }


                return (
                  action.actionType === 'GroupOfActions' ? (<>
                    <Dropdown menu={topLevelActionGroups.get(action.displayName) ?? {}}>
                      <Button color="default" variant="outlined" key={index} className="mt-0 mr-2">
                        <Space>
                          {action.iconName && <CustomIcon name={action.iconName || "faEdit"}></CustomIcon>
                          }
                          <span className={action.iconName ? "hide-on-mobile" : ""}>{action.displayName}</span>
                          <DownOutlined
                            rev="show-actions"
                          />
                        </Space>
                      </Button>
                    </Dropdown>
                  </>) :
                    <Button
                      key={index}
                      color="primary"
                      variant="outlined"
                      style={{ boxShadow: 'none' }}
                      onClick={() => handleTopLevelAction(action)}
                      disabled={disableTopActionButton(action)}
                      className="mt-0 mr-2"
                      icon={action.iconName && <CustomIcon height="14px" width="14px" name={action.iconName} color={disableTopActionButton(action) ? "#322b5d4c" : undefined} > </CustomIcon>}
                    >
                      <span className={action.iconName ? "hide-on-mobile" : ""}>{action.displayName}</span>

                    </Button>
                )
              }
              )}


            {moduleCode === 'loanAllocation' && <AutoAllocation></AutoAllocation>}




            {displayMode === 'table' && <Popover
              showArrow={false}
              placement="bottomLeft"
              content={
                <CheckboxGroup
                  style={{ display: "grid", gridGap: "0.5rem" }}
                  options={columnList.current}
                  value={hiddenColumns}
                  onChange={(cols: any) => {
                    setHiddenColumns(cols);
                  }}
                />
              }
              title="Hidden columns" trigger="click">
              <Button className="mr-1"> <CustomIcon name="hideColumns" title={"Hide Columns"}></CustomIcon>
                <span className="hide-on-mobile"> {hiddenColumns.length > 0 ? hiddenColumns.length + " Hidden" : "Hide Column"}</span>
              </Button>
            </Popover>}

            {(columnData.enableMultipleDisplayModes && columnData.availableDisplayModes && columnData.availableDisplayModes.length > 0) && <Segmented value={displayMode} size="large" className="align-middle mt-0 mr-2 font-semibold display-mode"
              onChange={(value: any) => setDisplayMode(value)}
              options={columnData.availableDisplayModes.map((item: any) => {

                return {
                  label: item.label,
                  value: item.value,
                  icon: item.value === 'table' ? <BarsOutlined style={{ color: "inherit" }} /> : <AppstoreOutlined style={{ color: "inherit" }} />
                };

              })}
            />}


          </div>
        </div>
      );
    }
  };

  const mainTableColumns = (() => {

    let headers = createTableHeaders();

    headers = headers.filter((item: any) => {
      return !hiddenColumns.includes(item.key);
    });

    if (openInFieldSearchModal) {
      return new ColumnsBuilder().basedOn(headers).build()
    } else {
      return new ColumnsBuilder().basedOn(headers).merge("action", {
        render: (record: any) => { return handleActionsButton(record) },
      }).build();
    }

  })();

  const recordMappings = (): Map<string, string> => {
    let rowValueMappings = new Map<string, string>();

    if (uniqueIds && uniqueIds.length > 0) {
      rowValueMappings.set("recordIds", uniqueIds?.join(",") ?? "");
      rowValueMappings.set("size", uniqueIds?.length.toString() ?? "1");
    }

    if (isCreateFlow && !isRelatedInfo) {
      return rowValueMappings;
    }

    Object.keys(mappings).map(function (key) {
      rowValueMappings.set(key, rowItemData[mappings[key]] ?? '');
    });

    return rowValueMappings;
  };

  const onSort = (x: any, y: any, sorter: any, SorterResult: any) => {

    setSortInfo(sorter);

    let newRecords = SorterResult.currentDataSource.map((item: any, index: number) => {
      return {
        ...item, srno:
          index +
          1 +
          ((tableParams?.pagination?.current || 1) *
            (tableParams?.pagination?.pageSize || 1) -
            (tableParams?.pagination?.pageSize || 1)),
      }
    })
    setRecords(newRecords)
  };

  const callback = useCallback(() => {
    reloadData();
    setuniqueIds([]);
    setSelectedRows([]);
  }, [reloadData]);

  const getDetailPage = (): any => {
    if (renderCustomViewPage) { // If custom details page is set - use it - else by default use ViewRecord
      if ((moduleCode ? moduleCode : title) === "profiles") {
        return (
          <Suspense>
            <ViewProfile
              open={openAction}
              isCreateFlow={isCreateFlow}
              isRelatedInfo={isRelatedInfo}
              setOpen={(val: any) => setOpenAction(val)}
              urlparams={recordMappings()}
              userAccessLevel={loggedInUserAccess}
              refreshData={callback}
            />
          </Suspense>

        );
      }
    }
    return (
      <ViewRecord
        open={openAction}
        isCreateFlow={isCreateFlow}
        isRelatedInfo={isRelatedInfo}
        isNewRelatedInfo={isNewRelatedInfo}
        setOpen={(val: any) => { sideDrawerTitle.current = title; isReloadDetailsPage.current = false; setOpenAction(val) }}
        urlparams={recordMappings()}
        blueprintApi={actionUrl}
        dataApi={recordDetailsDataApi}
        header={recordHeaderDetails}
        title={t(sideDrawerTitle.current)}
        userAccessLevel={loggedInUserAccess}
        platformAction={platformAction}
        recordIds={[...uniqueIds]}
        loanNos={[...uniqueLoanNos]}
        customerNames={[...uniqueCustomerNames]}
        refreshTable={callback}
        allowEdits={isEditAllowed}
        selectedRows={[...selectedRows]}
        // prefillColumns={[...prefillColumns]}
        moduleCode={moduleCode!}
        renderCustomDetailPage={isReloadDetailsPage.current ? undefined : renderCustomDetailPage}
        allowedActionsForRenderingCustomDetailPage={allowedActionsForRenderingCustomDetailPage}
        steps={stepDetailsOfRecord}
        extraActionsOnRecordCallback={extraActionsOnRecordCallback}
      />
    );
  };

  const showBulkUpload = () => {
    setBulkUpload(true);
  };

  const onCloseBulkUpload = () => {
    setBulkUpload(false);
  };



  const getSearchQuery = useCallback((queryStr: string, selectedSearchFilters: any, mode: 'quick' | 'advanced') => {


    setData({ records: [] });
    searchString.current = queryStr;

    //Selected filters are fetched from search module to be rendered their value in input fields 
    // useRef hook is used to preserve their value between rerenders
    searchFilterRef.current = selectedSearchFilters;

    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: 1,
      },
    });

  }, []);


  return (
    <div className="users-container">
      <div className="top-area">

        <div>
          <Text className="text-primary font-medium text-2xl">{title}</Text>

          <Text type="danger" className="font-medium text-base mx-1">
            {SelectedTotal ? SelectedTotal !== 0 ? <>Total:{SelectedTotal}</> : null : null}
          </Text>

          <Text type="danger" className="font-medium text-base mx-1">
            <HighlightsComponent highlightSections={columnData?.highlightSections ?? []} />
          </Text>
        </div>


        <div className="data-table-actions">
          <div className="w-100">{renderTopLevelActions()}</div>
        </div>


        <Drawer
          title="Bulk Upload"
          placement="right"
          onClose={onCloseBulkUpload}
          open={openBulkUpload}
        >
          <BulkUpload setOpen={setBulkUpload} action={bulkUploadAction!} moduleName={title} />
        </Drawer>
      </div>

      <div>

        {/* <div>
              {(openInFieldSearchModal && searchForm && searchForm.length > 0) && (
                <SearchFilterModule searchFilters={getSelectedQuickFiltersWithValues} searchForm={searchForm} getSearchQuery={getSearchQuery} mode={"quick"}></SearchFilterModule>
              )}
              {((searchForm && !openInFieldSearchModal) && searchForm.find((item: any) => { return item.selectedByDefault == true || item.quickSearchFilter == true })) &&
                <SearchFilterModule searchFilters={getSelectedQuickFiltersWithValues} searchForm={searchForm} getSearchQuery={getSearchQuery} mode={"quick"}></SearchFilterModule>}
            </div> */}

        <div>
          <Suspense fallback={<div className="text-center py-5"> <CustomLoader size="lg"></CustomLoader> </div>}>
            <SearchFilterModule moduleName={title} searchForm={searchForm} getSearchQuery={getSearchQuery} showAdvanced={!openInFieldSearchModal} />
          </Suspense>
        </div>
      </div>

      {tableLoading ? <CustomLoader size="lg"></CustomLoader> : <div>

        {displayMode === 'table' && <Table
          locale={customEmptyMessage(emptyMessageString.current)}
          id="main-platform-table"
          dataSource={records || []}
          className="custom-table"
          columns={mainTableColumns}
          loading={tableLoading}
          rowSelection={getRowSelectionConfig()}
          rowKey={mappings ? mappings["recordId"] : 'srno'}
          scroll={{ x: true, y: 500 }}
          pagination={{
            ...tableParams?.pagination,
            onChange: () => setTableParams({ ...tableParams }),
          }}
          sortDirections={['ascend', 'descend']}
          onChange={onSort}
          rowClassName={getRowClassName} />}

        {displayMode === 'cards' && <CardList handleMoreActions={handleMoreActions} handleRowLevelAction={handleRowLevelAction} items={records} blueprint={columnData}></CardList>}

        {displayMode === 'grid' && <CardGrid recordId={searchFieldKey as string} openInFieldSearchModal={openInFieldSearchModal} blueprint={columnData} deleteMethod={showDeleteConfirmationDialog} handleRowLevelAction={handleRowLevelAction} records={records}></CardGrid>}

      </div>}


      <div className="d-flex mb-2 mt-3">
        <Select
          placeholder="Select a pages"
          value={tableParams.pagination?.pageSize}
          disabled={tableLoading}
          onChange={(value) => {
            setData({ records: [] });
            setTableParams({
              ...tableParams,
              pagination: {
                ...tableParams.pagination,
                pageSize: value,
                current: 1,
              },
            });
          }}
          options={[10, 20, 30, 50].map((pageRecordLength) => ({
            key: pageRecordLength,
            value: pageRecordLength,
            label: pageRecordLength
          }))}
        />
        <div className="mx-2 ">


          <Button
            disabled={(tableParams.pagination?.current === 1) || tableLoading}

            className="px-2 mr-2"

            onClick={() => {
              setDisableNextButton(false);
              setData({ records: [] });
              setTableParams({
                ...tableParams,
                pagination: {
                  ...tableParams.pagination,
                  current: (tableParams.pagination?.current || 1) - 1
                },
              })
            }
            }
            color="primary"
            variant="filled"
            htmlType="button"
          >
            <LeftOutlined
              className="text-white d-inline mx-1"

            />

          </Button>


          <Button
            color="primary"
            variant="filled"
            className="px-2"
            disabled={disableNextButton || tableLoading}
            onClick={() => {
              if (!tableLoading) { // Do not change while table loading is true - ie., API call is in progress
                setTableParams({
                  ...tableParams,
                  pagination: {
                    ...tableParams.pagination,
                    current: (tableParams.pagination?.current || 1) + 1
                  },
                })
              }
            }
            }>
            <RightOutlined
              className="text-white mx-1"
            />
          </Button>

        </div>
      </div>

      {(rowItemData || isCreateFlow) && <div className="panel-dark">{getDetailPage()}</div>}
    </div>
  );
};

export default React.memo(PlatformTableComponent);
